import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUsersSelectListModule } from '@portal-core/license-users/components/license-users-select-list/license-users-select-list.module';
import { LicenseUserAsyncModule } from '@portal-core/license-users/pipes/license-user-async/license-user-async.module';
import { ProjectFilePickerInputModule } from '@portal-core/project-files/components/project-file-picker-input/project-file-picker-input.module';
import { TocAvatarModule } from '@portal-core/project-files/components/toc-avatar/toc-avatar.module';
import { ReviewFileUserStatusTextModule } from '@portal-core/reviews/review-file-users/pipes/review-file-user-status-text/review-file-user-status-text.module';
import { ReviewPackageConfirmCompleteDialogModule } from '@portal-core/reviews/review-packages/components/review-package-confirm-complete-dialog/review-package-confirm-complete-dialog.module';
import { ReviewPackageResolveChangesDialogModule } from '@portal-core/reviews/review-packages/components/review-package-resolve-changes-dialog/review-package-resolve-changes-dialog.module';
import { ReviewPackageWorkspaceMergeProgressDialogModule } from '@portal-core/reviews/review-packages/components/review-package-workspace-merge-progress-dialog/review-package-workspace-merge-progress-dialog.module';
import { ReviewPackageStatusTextModule } from '@portal-core/reviews/review-packages/pipes/review-package-status-text/review-package-status-text.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { ReviewPackageSettingsFormComponent } from './review-package-settings-form.component';

@NgModule({
  declarations: [ReviewPackageSettingsFormComponent],
  exports: [ReviewPackageSettingsFormComponent],
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormControlErrorMessageModule,
    LicenseUsersSelectListModule,
    LicenseUserAsyncModule,
    LicenseUserAvatarModule,
    LoaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    ProjectFilePickerInputModule,
    ReactiveFormsModule,
    ReviewFileUserStatusTextModule,
    ReviewPackageConfirmCompleteDialogModule,
    ReviewPackageResolveChangesDialogModule,
    ReviewPackageWorkspaceMergeProgressDialogModule,
    ReviewPackageStatusTextModule,
    TocAvatarModule,
    DropdownArrowModule
  ]
})
export class ReviewPackageSettingsFormModule { }
